module.exports = __webpack_public_path__ + "img/54.a939494.jpg";